export const enum Scope {
    WEATHER_READ = 'policy/hems/weather:read', // Read weather data
    ME_READ = 'policy/hems/user:read', // Read user data
    ME_WRITE = 'policy/hems/user:write', // Write user data
    TARIFF_READ = 'policy/hems/user/tariff:read', // Read user tariff
    TARIFF_WRITE = 'policy/hems/user/tariff:write', // Write user tariff
    EMOBILITY_BONUS_READ = 'policy/hems/user/bonus:read', // Read user bonus for autopilot charging
    HOME_SMART_READ = 'policy/hems/gridx/homesmart:read', // Read user data for smart charging bonus
    SMARTHOME_PAIRING_READ = 'policy/hems/smarthome/pairing:read', // Read iot data
    SMARTHOME_PAIRING_WRITE = 'policy/hems/smarthome/pairing:write', // Write iot data
    NOTIFICATION_READ = 'policy/hems/notification:read', // Read notifications data
    NOTIFICATION_WRITE = 'policy/hems/notification:write', // Write notifications data
    PVFORECAST_READ = 'policy/hems/forecast/pvforecast:read', // Read PV forecast data
    ENERGYDEVICES_PVB_READ = 'policy/hems/energydevices/pvb:read', // Read pvb data
    ENERGYDEVICES_PVB_WRITE = 'policy/hems/energydevices/pvb:write', // Write pvb data
    ENERGYDEVICES_GCP_READ = 'policy/hems/energydevices/gcp:read', // Read gcp data
    ENERGYDEVICES_ELECTRIC_CAR_READ = 'policy/hems/energydevices/electric-car:read', // Get charging
    ENERGYDEVICES_ELECTRIC_CAR_WRITE = 'policy/hems/energydevices/electric-car:write', // Update ev
    ENERGYDEVICES_EV_READ = 'policy/hems/energydevices/ev:read', // Get charging
    ENERGYDEVICES_EV_WRITE = 'policy/hems/energydevices/ev:write', // Update ev
    ENERGYDEVICES_GAS_READ = 'policy/hems/energydevices/gas:read', // Read gas data
    ENERGYDEVICES_GAS_WRITE = 'policy/hems/energydevices/gas:write', // Write gas data
    ENERGYDEVICES_GATEWAY_READ = 'policy/hems/energydevices/gateway:read', // Read gateway device data
    ENERGYDEVICES_GATEWAY_WRITE = 'policy/hems/energydevices/gateway:write', // Write gateway device data
    ENERGYDEVICES_HEAT_PUMP_READ = 'policy/hems/energydevices/heatpump:read', // Read heat pump device data
    ENERGYDEVICES_HEAT_PUMP_WRITE = 'policy/hems/energydevices/heatpump:write', // Write heat pump device data
    CARBONDIOXIDE_AVOIDED_READ = 'policy/hems/carbondioxide/avoided:read', // Read carbon footprint data. How much was avoided
    BENCHMARK_READ = 'policy/hems/insights/benchmark:read', // Read similar homes data
    DISAGGREGATION_READ = 'policy/hems/insights/disaggregation:read', // Read disaggregation data
    EMOBILITY_SMART_CHARGING_READ = 'policy/hems/ev/smartCharging:read', // Read ev smart charging data
    EMOBILITY_SMART_CHARGING_WRITE = 'policy/hems/ev/smartCharging:write', // Write ev smart charging data
    EMOBILITY_SOLAR_CHARGING_READ = 'policy/hems/ev/solarCharging:read',
    EMOBILITY_SOLAR_CHARGING_WRITE = 'policy/hems/ev/solarCharging:write',
    EMOBILITY_DYNAMIC_PRICE_CHARGING_READ = 'policy/hems/ev/dynamicPriceCharging:read',
    EMOBILITY_DYNAMIC_PRICE_CHARGING_WRITE = 'policy/hems/ev/dynamicPriceCharging:write',
    EMOBILITY_AUTOPILOT_WRITE = 'policy/hems/ev/autopilot:write',
    EMOBILITY_AUTOPILOT_READ = 'policy/hems/ev/autopilot:read',
    EMOBILITY_AUTOPILOT_GRIDX_WRITE = 'policy/hems/ev/autopilot-gridx:write',
    EMOBILITY_AUTOPILOT_GRIDX_READ = 'policy/hems/ev/autopilot-gridx:read',
    EMOBILITY_EEA_FLEX_WRITE = 'policy/hems/ev/eeaFlex:write',
    EMOBILITY_EEA_FLEX_READ = 'policy/hems/ev/eeaFlex:read',
    EMOBILITY_INNOVATION_WRITE = 'policy/hems/ev/innovation:write',
    EMOBILITY_INNOVATION_READ = 'policy/hems/ev/innovation:read',
    EMOBILITY_BIDIRECTIONAL_CHARGING_READ = 'policy/hems/ev/bidirectionalCharging:read',
    EMOBILITY_BIDIRECTIONAL_CHARGING_WRITE = 'policy/hems/ev/bidirectionalCharging:write',
    EMOBILITY_COMBINED_CHARGING_READ = 'policy/hems/ev/combined-charging:read',
    BILLING_REGION_READ = 'policy/hems/user/billingRegion:read',
    BILLING_REGION_WRITE = 'policy/hems/user/billingRegion:write',
    GRID_SUPPORTIVE_CONTROL_READ = 'feature-flag/alpha/grid-supportive-control/gridx-14a:read',
    GRID_SUPPORTIVE_CONTROL_WRITE = 'feature-flag/alpha/grid-supportive-control/gridx-14a:write',
    PVFORECAST_WRITE = 'policy/hems/forecast/pvforecast:write',
    EMOBILITY_PVFORECAST_READ = 'policy/hems/ev/pvForecast:read',
    GRIDX_TIME_OF_USE_READ = 'policy/hems/gridx/tou:read', // Access gridX time of use feature
    GRIDX_TIME_OF_USE_WRITE = 'policy/hems/gridx/tou:write', // Change gridX time of use settings
    GRIDX_TIME_OF_USE_MOTIVES_READ = 'policy/hems/gridx/tou/motives:read', // Access gridX ToU Battery feature page
    GRIDX_TIME_OF_USE_SESSION_INSIGHTS_READ = 'policy/hems/gridx/tou/session-insights:read', // Access gridX time of use session insights features
    HISTORICAL_HEMS_READ = 'policy/hems/history:read',
    HISTORICAL_FLEX_READ = 'policy/flex/history:read',
    GRIDX_ASSET_MONITORING_READ = 'policy/hems/fullassetmonitoring:read', // Access Full Asset Monitoring
    EV_SMART_CHARGING_C2C_READ = 'policy/hems/ev/smart-charging-c2c:read',
    HOME_COMFORT_APP_PROMO_BANNER_READ = 'policy/hems/notification/home-comfort-app-promo-banner:read',
    GRIDX_HOME_COMFORT_WEB_APP_BLOCKER_READ = 'policy/hems/gridx/home-comfort-web-app-blocker:read', // Block web app access for Home Comfort users
}

export type ScopeType = string[] | Scope[];
